import { Controller } from "stimulus";
import Quill from "quill";

export default class extends Controller {
  static get targets() {
    return ["hiddenField", "display"];
  }

  connect() {
    this.load();
  }

  load() {
    this.editor = new Quill("#" + this.displayTarget.id, this.options);
    this.editor.on("editor-change", this.updateHiddenField.bind(this));

    if (this.hiddenFieldTarget.value) {
      this.editor.setContents(this.editor.clipboard.convert(this.hiddenFieldTarget.value));
    }
  }

  updateHiddenField() {
    const html = this.editor.root.innerHTML;
    const parsedContent = new DOMParser().parseFromString(html, "text/html");
    this.hiddenFieldTarget.value = parsedContent.body.textContent ? html : "";
  }

  handleHitEnter(event) {
    const enterKeyCode = 13;

    if (event.keyCode === enterKeyCode) {
      event.stopPropagation();
    }
  }

  get options() {
    return {
      placeholder: this.displayTarget.dataset.placeholder,
      modules: {
        toolbar: this.displayTarget.dataset.tools.split(" ")
      },
      theme: this.displayTarget.dataset.theme
    };
  }
}
